module.exports = __webpack_public_path__ + "img/2_78.6a317800.png";